/** OpenWeather icon codes → plain monochrome symbols (no color emoji). */
const ICON_SYMBOL = {
  "01d": "\u2600", // ☀
  "01n": "\u263D", // ☽
  "02d": "\u26C5", // ⛅
  "02n": "\u2601", // ☁
  "03d": "\u2601",
  "03n": "\u2601",
  "04d": "\u2601",
  "04n": "\u2601",
  "09d": "\u2602", // ☂
  "09n": "\u2602",
  "10d": "\u2602",
  "10n": "\u2602",
  "11d": "\u26A1", // ⚡
  "11n": "\u26A1",
  "13d": "\u2744", // ❄
  "13n": "\u2744",
  "50d": "\u2248", // ≈
  "50n": "\u2248",
};

const DESC_SYMBOL = [
  [/thunder|storm/i, "\u26A1"],
  [/snow|sleet|blizzard/i, "\u2744"],
  [/rain|drizzle|shower/i, "\u2602"],
  [/fog|mist|haze|smoke/i, "\u2248"],
  [/cloud|overcast/i, "\u2601"],
  [/clear|sunny|fair/i, "\u2600"],
  [/partly|few clouds/i, "\u26C5"],
];

export const WEATHER_ICON_FONT =
  "Segoe UI Symbol, Calibri, Segoe UI, sans-serif";

/**
 * @param {string} [iconCode] OpenWeather icon id (e.g. "02d", "01n")
 * @param {string} [description] Human-readable condition fallback
 */
export function weatherIconEmoji(iconCode, description) {
  if (iconCode && ICON_SYMBOL[iconCode]) {
    return ICON_SYMBOL[iconCode];
  }
  const desc = String(description || "").trim();
  for (const [re, symbol] of DESC_SYMBOL) {
    if (re.test(desc)) return symbol;
  }
  return "\u25CB"; // ○
}
